(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gx-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.gxReady) return;
      root.dataset.gxReady = '1';
      const slides = [...root.querySelectorAll('.gx-banner__slide')];
      const dots = [...root.querySelectorAll('[data-gx-dot]')];
      if (slides.length < 2) return;
      let index = 0;
      let timer;
      const go = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((s, i) => {
          s.classList.toggle('is-active', i === index);
          s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      };
      const seconds = parseInt(root.dataset.autoplay, 10) || 0;
      const restart = () => {
        clearInterval(timer);
        if (seconds > 0) timer = setInterval(() => go(index + 1), seconds * 1000);
      };
      root.querySelector('[data-gx-prev]')?.addEventListener('click', () => { go(index - 1); restart(); });
      root.querySelector('[data-gx-next]')?.addEventListener('click', () => { go(index + 1); restart(); });
      dots.forEach((d) => d.addEventListener('click', () => { go(Number(d.dataset.gxDot)); restart(); }));
      let startX = null;
      root.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); restart(); }
        startX = null;
      });
      root.addEventListener('mouseenter', () => clearInterval(timer));
      root.addEventListener('mouseleave', restart);
      restart();
    };
    const boot = () => document.querySelectorAll('[data-gx-slider]').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
